// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { BehaviorSubject } from 'rxjs';

// Models
import { CaseShort } from 'app/_models/case-short.model';
import { CommonService } from 'app/reusable/common.service';
import { environment } from "environments/environment";


@Injectable({
    providedIn: 'root'
})
export class CaseService {

    public serverUrlSlot2 : string = environment.Services.AlphaURLSlot2;


    constructor(private commonService: CommonService) {

    }

    private case$ = new BehaviorSubject<CaseShort>(new CaseShort());

    public setCase(caseData: CaseShort): void {
        this.case$.next(caseData);
    }

    public getCase() {
        return this.case$.asObservable();
    }

    public clearCase() {
        this.case$.next(new CaseShort());
    }
    getCauseDetailName= async(ctyCaseDetailId)=>
    {   
        let GetCaseDetailByIdUrl = "CaseDetail/GetById/" +ctyCaseDetailId;
        const {cdName}: any = await this.commonService.getData(GetCaseDetailByIdUrl, this.serverUrlSlot2).first().toPromise()
        if(cdName)
             return cdName.trim();
        return "";
    }  
}
